import { createListenerMiddleware } from "@reduxjs/toolkit";
import { actions } from "../model/slice.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: actions.setCurrentPage,
  effect: (action, listenerApi) => {
    if (action.payload) {
      listenerApi.dispatch(actions.addVisitedPage(action.payload));
    }
  }
});
const { middleware } = listenerMiddleware;
export {
  middleware
};
